module.exports = __webpack_public_path__ + "img/tshirt1.091489fa.svg";